<script>
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);
export default {
  name: "premios",
  data() {
    return {};
  },
  props: {
    header: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      var swiper = new Swiper(this.$refs["mySwiper4"], {
        slidesPerView: 3,
        spaceBetween: 20,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: this.$refs["swiper-pagination4"],
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 6,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 6,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 10,
          },
        },
      });
    },
  },
};
</script>

<template>
  <section id="awards" class="awards">
    <div class="container">
      <header v-if="header">
        <h2>Prêmios</h2>
        <p>
          Ano após ano, os altos padrões de excelência são reconhecidos pelos
          clientes, colegas e organizações, rendendo premiações nacionais e
          internacionais, que colocam Gusmão & Labrunie como uma das principais
          referências em Direito de Propriedade Intelectual no Brasil.
        </p>
      </header>
      <div class="swiper-container swiper mySwiper mySwiper4" ref="mySwiper4">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/iam100.png" alt="Logo iam100" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/chambers.png" alt="Logo Chambers" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/www.png" alt="Logo Who's who legal" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/analise-advocacia.png" alt="Logo Análise advocacia 500" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/ip-stars.png" alt="Logo IP Stars" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/latin-lawyer.png" alt="Logo Latin lawyer 250" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/leaders-league.png" alt="Logo Leaders league" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/the-legal-500.png" alt="Logo The Legal 500" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/wtr.png" alt="Logo WTR" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="box-logo">
              <img src="@/views/home/assets/images/latin-lawyer-2.png" alt="Logo Latin Lawyer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  .awards {
    padding: 4rem 0px 7rem 0rem;
    @include media-breakpoint-down(sm) {
      padding: 2rem 0px 5rem 0rem;
    }
    header {
      text-align: center;
      h2 {
        color: theme-color(primary);
      }
    }
    p {
      padding: 1.5rem 0px;
      text-align: left;
      margin-bottom: -40px;
    }
    img {
      width: 100%;
      height: auto;
    }
    .box-logo {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px;
      img {
        border-radius: 6px;
        box-shadow: 0 0 10px #ccc;
      }
    }
  }
</style>
